"use strict";

const NewProjectInspectionValidator = function () {
  var getMissingRequiredFields = function (allData) {
    return FormValidator.getEmptyRequiredFieldsInData(
      allData,
      getMissingGeneralInfoFields(allData),
    );
  };

  var getMissingGeneralInfoFields = function (data) {
    var fields = [];

    fields.push({
      fieldName: "inspector-name",
      message: data["inspectionType"] === "follow-up-informal" ? "Reviewer Name" : "Inspector Name",
    });

    fields.push({
      fieldName: "start-time",
      message: "Inspection Date & Start Time",
    });

    fields.push({
      fieldName: "inspection-type",
      message: "Inspection Type",
    });

    const observationData = Tree.get("currentProjectInspectionObservationData");
    if (observationData?.nonCompliantFindingsCount > 0) {
      fields.push({
        fieldName: "follow-up-inspection-type",
        message: "Follow Up Type",
      });
      fields.push({
        fieldName: "followUpInspectionDate",
        message: "Follow Up Due Date",
      });
    }

    if (data["inspectionType"] !== "follow-up-informal") {
      fields.push({
        fieldName: "isSiteRepPresent",
        message: "Is the site representative on site?",
      });
    }

    fields.push({
      fieldName: "flagEnforcement",
      message: "Flag for new enforcement",
    });

    if (data.isSiteRepPresent) {
      fields.push({
        fieldName: "signatures[siteRepDate]",
        message: "Site representative signature date",
      });
      fields.push({
        fieldName: "signatures[siteRepName]",
        message: "Site representative name",
      });
      fields.push({
        fieldName: "signatures[siteRepEsignature]",
        message: "Site representative signature",
      });
    }

    fields.push({
      fieldName: "end-time",
      message: "Inspection End Date & Time",
    });
    fields.push({
      fieldName: "signatures[inspectorName]",
      message: data["inspectionType"] === "follow-up-informal" ? "Reviewer Name" : "Inspector Name",
    });
    fields.push({
      fieldName: "signatures[inspectorEsignature]",
      message:
        data["inspectionType"] === "follow-up-informal"
          ? "Reviewer signature"
          : "Inspector signature",
    });

    const noConditionObservations = getObservationsWithoutCondition(data);
    if (noConditionObservations.length) {
      fields.push({
        fieldName: "",
        message: `No Condition Value - Count ${noConditionObservations.length}`,
      });
    }

    return fields;
  };

  const getObservationsWithoutCondition = function (data) {
    const noConditionObservations = [];
    for (const constantId in data.inspectionObservations) {
      const constant = NewProjectInspectionConstants.getConstantById(parseInt(constantId, 10));
      if (!constant?.multipleObservations) {
        continue;
      }

      for (const [slot, observation] of data.inspectionObservations[constantId].entries()) {
        if (!observation || observation.deleted) {
          continue;
        }

        // Saved observations for open findings are moved into openFindings, so form edits made
        // on re-open (e.g. notes only) arrive without the condition saved earlier. Those edits
        // are keyed by observation index, which only matches the array slot when unindexed.
        const index = observation.index ?? slot;
        const condition =
          "condition" in observation
            ? observation.condition
            : data.openFindings?.[constantId]?.[index]?.condition;
        if (condition === null || condition === undefined) {
          noConditionObservations.push(observation);
        }
      }
    }
    return noConditionObservations;
  };

  return {
    getMissingRequiredFields,
  };
};

module.exports = NewProjectInspectionValidator();

const FormValidator = require("../../general/formValidator");
const Tree = require("../../tree");
const NewProjectInspectionConstants = require("./newProjectInspectionConstants");
